import { useContext } from "react";
import { ThemeContext } from "../../Contaxt/ThemeContext";

const PageTitleBanner = ({ kicker, title = "FULL DEDEICATED & EXPERIENCED DEVELOPER" }) => {
    const { isLight } = useContext(ThemeContext);

    return (
        <section>
            <div className={`fw-main-row ${isLight ? "black-bg-content-LIGHT" : "black-bg-content"}`}>
                <div className="fw-full-container-top" style={{ backgroundImage: "url(/images/bg-dots.png)" }}>
                    <div className="fw-container">
                        <div className="fw-row">
                            <div className="fw-col-xs-12">
                                <div className="fw-divider-space"></div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center banner-seo-media-images">
                            <div className="seo-media-images-common">
                                <img className="top-image-arrow-1" src="/images/Vector-line-straight.png" alt="" />
                                <img className="top-image-arrow-2" src="/images/Vector-line-straight.png" alt="" />
                            </div>
                            <div className="seo-media-images-common">
                                <img className="top-image-arrow-3" src="/images/Vector-line-straight.png" alt="" />
                                <img className="top-image-arrow-4" src="/images/Vector-line-straight.png" alt="" />
                            </div>
                        </div>

                        <div className="content-under-image">
                            <div className="top-vector_main">
                                <img className="vector-line-common" src="/images/Vector-upper-arrow.png" alt="" />
                                <div className="fw-row">
                                    <div className="cector-cross-line-allign">
                                        <div className="vector-class-common">
                                            <div className="dots-first">
                                                <div className="dot-common"></div>
                                                <div className="dot-common"></div>
                                            </div>
                                            <img className="vector-cross-common" src="/images/vector.png" alt="" />
                                            <div className="dots-second">
                                                <div className="dot-common"></div>
                                                <div className="dot-common"></div>
                                            </div>
                                        </div>
                                        <div className="fw-heading fw-heading-h2 d-flex justify-content-center align-items-center">
                                            <h2 className={`${isLight ? "fw-special-title vector-heading-LIGHT" : "fw-special-title vector-heading"}`}>
                                                {kicker}
                                            </h2>
                                        </div>
                                        <div className="vector-class-common">
                                            <div className="dots-first">
                                                <div className="dot-common"></div>
                                                <div className="dot-common"></div>
                                            </div>
                                            <img className="vector-cross-common" src="/images/vector.png" alt="" />
                                            <div className="dots-second">
                                                <div className="dot-common"></div>
                                                <div className="dot-common"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img className="vector-line-common1" src="/images/Vector-upper-arrow.png" alt="" />
                            </div>

                            <div className="fw-row">
                                <div className="fw-col-xs-12">
                                    <div className="fw-divider-space" style={{ marginTop: "20px" }}></div>
                                </div>
                            </div>
                            <div className="fw-row">
                                <div className="container">
                                    <div className="fw-col-xs-12">
                                        <h1 className={`${isLight ? "heading-common-main-LIGHT" : "heading-common-main"}`}>
                                            {title}
                                        </h1>
                                    </div>
                                </div>
                            </div>

                            <div className="fw-row about-top-frame">
                                <div className="container">
                                    {!isLight && (
                                        <div className="fw-col-xs-12">
                                            <img
                                                className="services-image-desk"
                                                src="/images/TECHtechaboutus.webp"
                                                alt=""
                                                style={{ width: "80%" }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="fw-row">
                                <div className="fw-col-xs-12">
                                    <div className="fw-divider-space" style={{ marginTop: "50px" }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PageTitleBanner;
